import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useI18n } from '../i18n';
export const LinkFieldPicker = ({ value, openInNewWindow, label, name, onChange, }) => {
    const intl = useI18n();
    return (_jsxs("div", { className: "space-y-2", children: [_jsx(FormControl.Input, { name: name, value: value, onChange: e => {
                    onChange(e.target.value, openInNewWindow);
                }, label: label }, void 0), _jsx(FormControl.Toggle, { name: "openInNewWindow", label: intl.$t({
                    id: 'PickerField.LinkFieldPicker.ToggleLabelName',
                    defaultMessage: 'Open in a new window',
                }), checked: openInNewWindow, onChange: t => {
                    onChange(value, t);
                } }, void 0)] }, void 0));
};
//# sourceMappingURL=LinkFieldPicker.js.map